import { useCallback, useEffect, useState } from 'react'
import dayjs from 'dayjs'
import useWordings from '@v4/hooks/useWordings'
import useStyles from './Timer.styled'

export const useTimer = props => {
	const classes = useStyles(props)
	const { date, onDateBlockClick, timerColour } = props
	const { getWording } = useWordings()

	const calculateTimeRemaining = useCallback(() => {
		const targetDate = dayjs(date)
		const now = dayjs()

		if (!targetDate.isValid() || targetDate.isBefore(now)) {
			return {
				days: 0,
				hours: 0,
				minutes: 0,
				seconds: 0,
			}
		}

		return {
			days: targetDate.diff(now, 'day'),
			hours: targetDate.diff(now, 'hour') % 24,
			minutes: targetDate.diff(now, 'minute') % 60,
			seconds: targetDate.diff(now, 'second') % 60,
		}
	}, [date])

	const [timeRemaining, setTimeRemaining] = useState(calculateTimeRemaining)

	useEffect(() => {
		const intervalId = setInterval(() => {
			setTimeRemaining(calculateTimeRemaining())
		}, 1000)

		return () => clearInterval(intervalId)
	}, [calculateTimeRemaining])

	return [
		{
			classes,
			timeRemaining,
			timerColour,
			data: ['days', 'hours', 'minutes', 'seconds'],
			getWording,
		},
		{
			handleDateBlockClick: onDateBlockClick,
		},
	]
}
